module.exports = __webpack_public_path__ + "img/guillermo-colombo-byn.07ee0caf.png";